import { useEffect } from 'react'

export const RedirectToExternal = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.href = to
  }, [to])

  return null
}
